import { h } from 'preact'

export const TuileImage = ({ image, alt, analytics, URL }) => {
   return (
      <a
         href={URL}
         class="tuile-image lien-composite"
         data-pdb-zid={analytics.pdbZid}
         data-pdb-sc={analytics.pdbSc}
         data-pdb-idc={analytics.pdbIdc}
         data-pdb-vi={analytics.pdbVi}
         data-pdb-ta={analytics.pdbTa}
         data-adv-canal={analytics.advCanal}
         data-adv-cappingdata={analytics.advCappingdata}
         data-oevent-category={analytics.oeventCategory}
         data-oevent-action={analytics.oeventAction}
         data-oevent-label={analytics.oeventLabel}
         data-oevent-other={analytics.oeventOther}
      >
         <div class="image-container">
            <img class="bg-img" src={image} alt="" />
            <img class="img" src={image} alt={alt || ''} />
         </div>
      </a>
   )
}
